import React from 'react';
import { Control, Fieldset } from 'react-redux-form';
import {
  PLACEHOLDER_OPT,
} from './Schemas/baseRrf';
import Select, { SELECT_STYLE } from './Controls/Select';
import InputField from './Controls/Field';

import './styles.css';

const fields = [
  {
    model: '.type',
    RRFComp: Control,
    control: {
      component: Select,
      selectStyle: SELECT_STYLE.BLUE,
      errors: {
        required: val => !val || !val.length || val === PLACEHOLDER_OPT,
      },
    },
    error: {
      messages: {
        required: 'Please select the type of document being uploaded.',
      },
    },
  },
];

const UploadVerifyDocs = ({
  uploadDocsPath,
  docTypeOptions,
}) => (
  <Fieldset model={`${uploadDocsPath}.verifyDocs`}>
    <InputField
      key={fields[0].model}
      fieldProps={fields[0]}
    >
      {Object.keys(docTypeOptions).sort(a => (
        a === PLACEHOLDER_OPT ? -1 : 1)).map(key => (
          (key === PLACEHOLDER_OPT) ?
            <option key={key} disabled value={key}>{docTypeOptions[key]}</option>
          : <option key={key} value={key}>{docTypeOptions[key]}</option>
        ))}
    </InputField>
  </Fieldset>
);

export default UploadVerifyDocs;



// WEBPACK FOOTER //
// ./src/components/Forms/UploadVerifyDocs.js